export const ellipsize = (s, maxLen) => {
    maxLen = maxLen || 50
    s = s.toString()
    if (s.length > maxLen) {
        return s.substr(0, maxLen) + '...'
    }
    return s
}

export default {
    methods: {ellipsize}
}
